<template>
<div>
    <div class="amountMoney">
        <p>需支付</p>
        <b>¥{{payMoney}}</b>
    </div>
    <div class="paymethodGroup" v-if="payMethodList && payMethodList.length>0">
        <van-radio-group v-model="paymentMethod">
            <div class="paymethod-every" v-for="(item,index) in payMethodList" :key="index">
                <div class="paymethod-everyL" v-if="item==37"><img src="@/assets/images/wx.png" /><span>微信支付</span></div>
                <div class="paymethod-everyL" v-if="item==55"><img src="@/assets/images/zfb.png" /><span>支付宝支付</span></div>
                <div class="paymethod-everyR"><van-radio :name="item+''" checked-color="#FE5938"></van-radio></div>
            </div>
        </van-radio-group>
    </div>
    <div class="gotopaybtn" @click='!buttonClicked?gotoPay():""'>确认</div>
</div>
</template>
<script>
import Vue from "vue"
import payMethods from "../../components/payMethods"
export default {
    name: '',
    mixins: [payMethods],
    data () {
        return {
            title: '',
            paymentMethod:'37',
            payMethodList:[],
            payMoney:'0.00',
            buttonClicked: false
        }
    },
    mounted() {
        this.getOrderDetail(this.$route.query.orderId)
        this.getPayMethodList();
        let initTime = this.initTime
        this.$service.getStatisCommon("evn_dom_finish",{initTime: initTime});
    },
    methods: {
        buttonClick(){//防止重复点击按钮
            this.buttonClicked= true;
            setTimeout(function () {
            this.buttonClicked= false;
            }, 3000)
        },
        async getPayMethodList(params){
          let res = await this.$service.getPaymentMethodList(params);
          if (res && res.result && res.result.length>0) {
            this.paymentMethod=res.result[0]+'';
            this.payMethodList = res.result;
          }
        },
        async getOrderDetail(orderId){
            let reqData={
                params: {
                    "orderId": orderId,
                }
            }
            try{
              let res = await this.$service.getOrderDetail(reqData);
              if(res.status==200){
                  if(res.result.orderTransactionInfo.cashAmount){
                      this.payMoney=parseFloat(res.result.orderTransactionInfo.cashAmount).toFixed(2);
                  }
              }
            }catch(e){

            }
            let initTime = this.initTime
            this.$service.getStatisCommon("evn_open_page",{initTime:initTime})
        },
        gotoPay(){
            this.buttonClick();
            let params=JSON.parse(this.$route.query.args)
            params.paymentMethod=Number(this.paymentMethod)
            this.$service.getStatisCommon("evn_paymentMethod",{ed:params});
            this.$appPay(params)
        }
        
    },
    beforeRouteLeave (to, from, next) {
        if(from.path=='/checkout'){
            if(to.path=="/shoppingCar"){
                next('/orderList')
            }else if(to.path=="/orderList"){
                if(to.query.payRes==1){//成功支付中
                    to.query.active=0;
                    next()
                }else if(to.query.payRes==2){//失败待付款
                    if(localStorage.getItem(this.$env+"backpop")=="ok"){
                        localStorage.removeItem(this.$env+"backpop");
                        to.query.active=1;
                        next()
                    }else{
                        this.$dialog.confirm({
                            title: '',
                            message: '您的订单在规定时间内未支付将被取消，请尽快完成支付。',
                            confirmButtonText:"确认离开",
                            cancelButtonText:"继续支付",
                            confirmButtonColor:"#F84F24",
                            cancelButtonColor:"#F84F24"
                        }).then(() => {
                            to.query.active=1;
                            next()
                        }).catch(() => {
                            // on cancel
                            next(false)
                        });
                    }
                }else{
                    this.$dialog.confirm({
                        title: '',
                        message: '您的订单在规定时间内未支付将被取消，请尽快完成支付。',
                        confirmButtonText:"确认离开",
                        cancelButtonText:"继续支付",
                        confirmButtonColor:"#F84F24",
                        cancelButtonColor:"#F84F24"
                    }).then(() => {
                        to.query.active=1;
                        next()
                    }).catch(() => {
                        // on cancel
                        next(false)
                    });
                }
            }else if(to.path=="/orderDetail"){
                this.$dialog.confirm({
                    title: '',
                    message: '您的订单在规定时间内未支付将被取消，请尽快完成支付。',
                    confirmButtonText:"确认离开",
                    cancelButtonText:"继续支付",
                    confirmButtonColor:"#F84F24",
                    cancelButtonColor:"#F84F24"
                }).then(() => {
                    next()
                }).catch(() => {
                    // on cancel
                    next(false)
                });
            }else if(to.path=="/detail"){
              next()
            }
        }
    }
}
</script>
<style scoped lang="less">
.amountMoney{
    display:flex;
    height:3.6267rem;
    flex-flow: column;
    align-items:center;
    justify-content:center;
    font-size:0.3733rem;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
}
.amountMoney b{
    font-size:0.7467rem;
    height:1.0667rem;
    line-height:1.0667rem;
    margin-top:0.2133rem;
}
.paymethodGroup{
    border-top: 1px solid rgba(0,0,0,0.1);
    margin: 0 0.4267rem;
}
.paymethod-every{
    border-bottom: 1px solid rgba(0,0,0,0.1);
    height: 1.92rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.paymethod-everyL{
    display: flex;
    align-items: center;
}
.paymethod-everyL img{
    width: 0.8533rem;
    height: 0.8533rem;
}
.paymethod-everyL span{
    margin-left: 0.32rem;
    font-size:0.4267rem;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,0.86);
}
.gotopaybtn{
    width:9.1467rem;
    height:1.1733rem;
    line-height:1.1733rem;
    text-align:center;
    background:linear-gradient(270deg,rgba(254,89,56,1) 0%,rgba(255,167,51,1) 100%);
    border-radius:0.5867rem;
    font-size:0.4267rem;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(255,255,255,1);
    position: fixed;
    left: 0.4267rem;
    bottom:1.4933rem ;
}
</style>